module.exports = {
	"START": "スタート",
	"SINGLE_TYPED": "1種類のタイプ",
	"DOUBLE_TYPED": "2種類のタイプ",
	"BASIC": "基本",
	"SPEEDRUN": "タイムアタック",
	"HOME": "ホーム",
	"ATTACK": "攻撃",
	"DEFEND": "防御",
	"GOAL": "目標",
	"GOAL_BASIC": "60 秒以内に回答",
	"GOAL_SPEEDRUN": "目指せ 20 点",
	"TIMER": "タイマー",
	"SCORES": "スゴア",
	"YOUR_SCORES": "あなたのスゴアは",
	"YOUR_TIME": "あなたのタイムは",
	"RETRY": "やり直し",
	"MENU": "メニューに戻る",
	"LANGUAGE": "言語",
	"NORMAL": "ノーマル",
	"FIGHTING": "かくとう",
	"FLYING": "ひこう",
	"POISON": "どく",
	"GROUND": "じめん",
	"ROCK": "いわ",
	"BUG": "むし",
	"GHOST": "ゴースト",
	"STEEL": "はがね",
	"FIRE": "ほのお",
	"WATER": "みず",
	"GRASS": "くさ",
	"ELECTRIC": "でんき",
	"PSYCHIC": "エスパー",
	"ICE": "こおり",
	"DRAGON": "ドラゴン",
	"DARK": "あく",
	"FAIRY": "フェアリー",
	"EFFECTIVE_0": "効果がない",
	"EFFECTIVE_1_2": "効果は今一つ",
	"EFFECTIVE_1": "普通",
	"EFFECTIVE_2": "効果は抜群",
	"ENEMY_ATTACK": "敵を攻撃する",
	"ENEMY_DEFEND": "敵の攻撃を防御する"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lang/strings_ja.json
 ** module id = 321
 ** module chunks = 0
 **/